import React from "react";
import { Box, Container, Grid, Typography, Link } from "@mui/material";

const Footer = () => (
    <Box component="footer" sx={{ bgcolor: 'background.default', color: 'text.primary', width: '100%', py: 4, boxShadow: 3, position: 'relative', zIndex: 1 }}>
        <Container maxWidth={false} sx={{ px: { xs: 2, md: 6 } }}>
            <Grid
                container
                alignItems="center" // This centers items vertically
                direction="row"
            >
                <Grid item xs={12} md={8}>
                    <Typography
                        variant="body1"
                        sx={{
                            fontSize: 17,
                            color: 'text.primary',
                        }}
                    >
                        All Copy Rights Reserved by{" "}
                        <Link
                            href="http://Sarasjournal.com"
                            underline="hover"
                            sx={{ color: 'text.primary', cursor: "pointer" }}
                        >
                            Sarasjournal.com
                        </Link>
                        {" | "}
                        <Link href="#" underline="hover" sx={{ color: 'text.primary' }}>
                            Privacy Policy
                        </Link>
                        {" | "}
                        <Link href="#" underline="hover" sx={{ color: 'text.primary' }}>
                            Legal
                        </Link>
                        {" | "}
                        <Link href="#" underline="hover" sx={{ color: 'text.primary' }}>
                            Terms and Conditions
                        </Link>
                    </Typography>
                </Grid>
                <Grid
                    item
                    xs={12}
                    md={4}
                    sx={{
                        textAlign: { xs: "center", md: "right" }, // center on mobile
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: { xs: "center", md: "flex-end" }, // center vertically on mobile
                        alignItems: { xs: "center", md: "flex-end" }, // center horizontally on mobile
                        height: "70%",
                    }}
                >
                    <Box
                        component="img"
                        src="/assets/cyj-logo.jpeg"
                        alt="Sarasjournal Logo"
                        width={120}
                        loading="lazy"
                        sx={{ maxWidth: "80%" }}
                    />
                </Grid>

            </Grid>
        </Container>
    </Box>
);

export default Footer;